import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchApiResponse, SEARCH_API_INIT } from '../types/api/SearchApiType';

// 検索結果管理
const slice = createSlice({
    name: 'SearchResultData',
    // 初期値
    initialState: SEARCH_API_INIT,
    reducers: {
        // 全置換
        setState: (_state, action: PayloadAction<SearchApiResponse>) => action.payload,
        // 初期化
        initState: () => SEARCH_API_INIT,
    },
});

export const { actions, reducer } = slice;
export const { setState, initState } = actions;
